import { Button } from 'reactstrap';
import { FaFileExcel } from 'react-icons/fa';
import exportToSheet from 'utils/exportToSheet';

interface Material {
  descricao: string;
  diteCodigo: string;
  codigoSap?: string | null;
}

interface Planilha {
  material: Material;
  quantidade: number;
}

interface Props {
  data: Planilha[];
  className?: string;
  isLoadingMateriais: boolean;
}

export function DownloadPlanilha({
  data,
  className,
  isLoadingMateriais,
}: Props): JSX.Element {
  const exportarPlanilha2 = () => {
    const dadosPlanilha = [
      { codigo: '', material: '', quantidade: '' },
      ...data.map(item => ({
        codigo: item.material.codigoSap || item.material.diteCodigo,
        material: item.material.descricao,
        quantidade: item.quantidade,
      })),
    ];

    const nomeArquivo = `MateriaisExcluidosExportados`;
    exportToSheet(dadosPlanilha, nomeArquivo);
  };

  const exportarPlanilha = () => {
    const materiaisAgrupados = (data || []).reduce((acc, item, index) => {
      const { diteCodigo, descricao, codigoSap } = item.material;
      const { quantidade } = item;
      const codigo = codigoSap || diteCodigo;

      if (!acc[codigo]) {
        acc[codigo] = {
          codigo,
          material: descricao,
          quantidade,
        };
      } else {
        acc[codigo].quantidade += quantidade;
      }

      return acc;
    }, {} as Record<string, { codigo: string; material: string; quantidade: number }>);

    const dadosPlanilha = [
      { codigo: '', material: '', quantidade: '' },
      ...Object.values(materiaisAgrupados),
    ];

    const nomeArquivo = `MateriaisExcluidosExportados`;

    exportToSheet(dadosPlanilha, nomeArquivo);
  };

  return (
    <div className={className}>
      <Button
        size="sm"
        className="btn-icon btn-2"
        style={{ backgroundColor: '#1a8c5b' }}
        color="success"
        type="button"
        disabled={isLoadingMateriais}
        onClick={exportarPlanilha}
      >
        <FaFileExcel />
        <span className="btn-inner--text">Exportar materiais</span>
      </Button>
    </div>
  );
}
